import react, { useState } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { purple } from "@mui/material/colors";
import { BiLogoTypescript } from "react-icons/bi";
import {
  FaAws,
  FaDocker,
  FaGithub,
  FaJava,
  FaPhp,
  FaPython,
  FaReact,
  FaSwift,
} from "react-icons/fa";
import { RiFlutterFill } from "react-icons/ri";
import { IoLogoNodejs } from "react-icons/io";
import { SiAdobeillustrator } from "react-icons/si";
import { SiAdobephotoshop } from "react-icons/si";
import { SiAdobeindesign } from "react-icons/si";
import { SiAdobelightroom } from "react-icons/si";
import { SiCanva } from "react-icons/si";
import { IoLogoFigma } from "react-icons/io5";
import { SiBlender } from "react-icons/si";
import figma from "../../assets/images/icons8-figma.svg";
import canva from "../../assets/images/icons8-canva.svg";

export const techStacks = {
  "GRAPHIC DESIGNING": [
    {
      id: 1,
      name: "Illustrator",
      icon: (
        <SiAdobeillustrator className=" text-5xl md:text-7xl text-[#a0aac7] hover:text-[#38090f] transition duration-300 cursor-pointer" />
      ),
    },
    {
      id: 2,
      name: "Photoshop",
      icon: (
        <SiAdobephotoshop className=" text-5xl md:text-7xl text-[#a0aac7] hover:text-[#081f27] transition duration-300 cursor-pointer" />
      ),
    },
    {
      id: 3,
      name: "InDesign",
      icon: (
        <SiAdobeindesign className=" text-5xl md:text-7xl text-[#a0aac7] hover:text-[#2e0d1e] transition duration-300 cursor-pointer" />
      ),
    },
    {
      id: 4,
      name: "Lightroom",
      icon: (
        <SiAdobelightroom className=" text-5xl md:text-7xl text-[#a0aac7] hover:text-[#09253b] transition duration-300 cursor-pointer" />
      ),
    },
    {
      id: 5,
      name: "Canva",
      icon: (
        <SiCanva className=" text-5xl md:text-7xl text-[#a0aac7] hover:text-[#06a4f4] transition duration-300 cursor-pointer" />
       
      ),
    },
    {
      id: 6,
      name: "Blender",
      icon: (
        <SiBlender className=" text-5xl md:text-7xl text-[#a0aac7] hover:text-[#ed9243] transition duration-300 cursor-pointer" />
      ),
    },
  ],
   "UI/UX DESIGNING": [
    {
      id: 1,
      name: "Figma",
      icon: (
        <img
          src={figma}
          alt="Figma"
          className="w-12 md:w-16 cursor-pointer transition duration-300
                   grayscale hover:grayscale-0"
        />
      ),
    },
  ],
};

